import { InputLabel, Stack, TextField, Typography } from '@mui/material';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { HelperText } from '@shared/components';
import { useFormContext } from 'react-hook-form';
import { CreateSalesPriceConditionSchema } from './CreateSalesPriceConditionsForm';
import { calculateSalesFactorFromDG } from '@retail/utils';

interface Props {
  coverageDegree: number | null;
  setCoverageDegree: (coverageDegree: string | null) => void;
}

export function MarkupPriority({ coverageDegree, setCoverageDegree }: Props) {
  const t = useCalculusTFunction();

  const {
    register,
    clearErrors,
    formState: { errors },
  } = useFormContext<CreateSalesPriceConditionSchema>();

  return (
    <Stack flexGrow={1}>
      <Stack gap={2} flexDirection="row">
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography component={InputLabel} htmlFor="coverageDegree" variant="subtitle2">
            {t('calculus.coverageDegree')}:
          </Typography>
          <TextField
            id="coverageDegree"
            {...register('markupCoverageDegree')}
            sx={{ '& .MuiInputBase-input': { p: 0.5, width: 44, textAlign: 'center' } }}
            onChange={(e) => {
              setCoverageDegree(e.target.value);
              if (e.target.value === '') {
                setCoverageDegree(null);
                clearErrors('markupCoverageDegree');
              }
            }}
            size="small"
          />
        </Stack>

        <Stack direction="row" alignItems="center" gap={1}>
          <Typography variant="body2">{t('calculus.customerMarkup.factor')}:</Typography>
          <Typography variant="body2">
            {coverageDegree != null &&
            !isNaN(Number(coverageDegree)) &&
            Number(coverageDegree) < 100
              ? calculateSalesFactorFromDG(coverageDegree).toFixed(2)
              : '-'}
          </Typography>
        </Stack>
      </Stack>

      {errors.markupCoverageDegree && (
        <Stack>
          <HelperText id="markupCoverageDegree" status="error">
            {errors.markupCoverageDegree.message}
          </HelperText>
        </Stack>
      )}
    </Stack>
  );
}
